import { TreeDataElement } from "@/utils/tree-generation/tree-data";
import { IElementType, IElementTypeHint } from "@faro-lotv/ielement-types";

/**
 * @returns True if the input element is an area section
 * @param element The element to test
 */
export function isAreaSection(element?: TreeDataElement): boolean {
  return (
    !!element &&
    element.type === IElementType.section &&
    element.typeHint === IElementTypeHint.area
  );
}

/**
 * @returns True if the input element is a room section
 * @param element The element to test
 */
export function isRoomSection(element?: TreeDataElement): boolean {
  return (
    !!element &&
    element.type === IElementType.section &&
    element.typeHint === IElementTypeHint.room
  );
}
